import { render, staticRenderFns } from "./coupon.mpx?vue&type=template&id=6c2a6d3e&scoped=true&component=true&componentId=coupon35b69a59"
import script from "./coupon.mpx?vue&type=script&lang=js&component=true&componentId=coupon35b69a59"
export * from "./coupon.mpx?vue&type=script&lang=js&component=true&componentId=coupon35b69a59"
import style0 from "./coupon.mpx?vue&type=style&index=0&id=6c2a6d3e&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m35b69a59%22%7D&component=true&componentId=coupon35b69a59"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a6d3e",
  null
  
)

export default component.exports